// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var React = require("@tiptap/react");
var Extensions = require("@tiptap/extensions");
var StarterKit = require("@tiptap/starter-kit").default;
var ExtensionLink = require("@tiptap/extension-link").default;

var Heading = {};

var Nodes = {
  Heading: Heading
};

var Link = {};

var Marks = {
  Link: Link
};

var $$Node = {};

var State = {};

var ProseMirror = {
  $$Node: $$Node,
  State: State
};

function canChain(editor) {
  return editor.can().chain();
}

function getLinkAttributes(editor) {
  return Caml_option.nullable_to_opt(editor.getAttributes("link"));
}

var Attributes = {};

var EditorProps = {
  Attributes: Attributes
};

function noop(param) {
  
}

function make(content, onUpdate, onBlur, onFocus, editorProps, placeholderTextOpt, headingLevelsOpt, param) {
  var placeholderText = placeholderTextOpt !== undefined ? placeholderTextOpt : "";
  var headingLevels = headingLevelsOpt !== undefined ? headingLevelsOpt : [
      1,
      2,
      3
    ];
  return {
          content: content,
          extensions: [
            StarterKit.configure({
                  heading: {
                    levels: headingLevels
                  }
                }),
            Extensions.Underline,
            ExtensionLink.configure({
                  openOnClick: false,
                  validate: (function (value) {
                      var urlWithProtocolRegex = /^https?:\/\//g;
                      return urlWithProtocolRegex.test(value);
                    })
                }),
            Extensions.Placeholder.configure({
                  placeholder: placeholderText,
                  emptyEditorClass: "cursor-text before:content-[attr(data-placeholder)] before:absolute before:top-2 before:left-2 before:text-zinc-400"
                }),
            Extensions.Selection.configure({
                  className: "fake-selection"
                })
          ],
          onUpdate: Core__Option.getOr(onUpdate, noop),
          onBlur: Core__Option.getOr(onBlur, noop),
          onFocus: Core__Option.getOr(onFocus, noop),
          editorProps: editorProps,
          immediatelyRender: false,
          shouldRerenderOnTransaction: true
        };
}

function useEditor(config) {
  return Caml_option.nullable_to_opt(React.useEditor(config));
}

function Commands_toggleBold(prim) {
  return prim.toggleBold();
}

function Commands_toggleItalic(prim) {
  return prim.toggleItalic();
}

function Commands_toggleUnderline(prim) {
  return prim.toggleUnderline();
}

function Commands_toggleHeading(prim0, prim1) {
  return prim0.toggleHeading(prim1);
}

function Commands_toggleBulletList(prim) {
  return prim.toggleBulletList();
}

function Commands_toggleOrderedList(prim) {
  return prim.toggleOrderedList();
}

function Commands_focus(prim) {
  return prim.focus();
}

function Commands_extendMarkRange(prim0, prim1) {
  return prim0.extendMarkRange(prim1);
}

function Commands_setLink(prim0, prim1) {
  return prim0.setLink(prim1);
}

function Commands_unsetLink(prim) {
  return prim.unsetLink();
}

var Commands_Chainable = {
  run: (function (prim) {
      return prim.run();
    }),
  toggleBold: (function (prim) {
      return prim.toggleBold();
    }),
  toggleItalic: (function (prim) {
      return prim.toggleItalic();
    }),
  toggleUnderline: (function (prim) {
      return prim.toggleUnderline();
    }),
  toggleHeading: (function (prim0, prim1) {
      return prim0.toggleHeading(prim1);
    }),
  toggleBulletList: (function (prim) {
      return prim.toggleBulletList();
    }),
  toggleOrderedList: (function (prim) {
      return prim.toggleOrderedList();
    }),
  focus: (function (prim) {
      return prim.focus();
    }),
  extendMarkRange: (function (prim0, prim1) {
      return prim0.extendMarkRange(prim1);
    }),
  setLink: (function (prim0, prim1) {
      return prim0.setLink(prim1);
    }),
  unsetLink: (function (prim) {
      return prim.unsetLink();
    })
};

var Commands = {
  toggleBold: Commands_toggleBold,
  toggleItalic: Commands_toggleItalic,
  toggleUnderline: Commands_toggleUnderline,
  toggleHeading: Commands_toggleHeading,
  toggleBulletList: Commands_toggleBulletList,
  toggleOrderedList: Commands_toggleOrderedList,
  focus: Commands_focus,
  extendMarkRange: Commands_extendMarkRange,
  setLink: Commands_setLink,
  unsetLink: Commands_unsetLink,
  Chainable: Commands_Chainable
};

function Editor_commands(prim) {
  return prim.commands;
}

function Editor_chain(prim) {
  return prim.chain();
}

function Editor_canSingle(prim) {
  return prim.can();
}

function Editor_isActive(prim0, prim1) {
  return prim0.isActive(prim1);
}

function Editor_isHeadingActive(prim0, prim1) {
  return prim0.isActive("heading", prim1);
}

function Editor_getHTML(prim) {
  return prim.getHTML();
}

function Editor_getText(prim) {
  return prim.getText();
}

function Editor_isEmpty(prim) {
  return prim.isEmpty;
}

function Editor_state(prim) {
  return prim.state;
}

function Editor_internal_startDomObserver(prim) {
  prim.view.domObserver.start();
}

function Editor_internal_stopDomObserver(prim) {
  prim.view.domObserver.stop();
}

var Editor_Config = {
  EditorProps: EditorProps,
  make: make
};

var Editor = {
  commands: Editor_commands,
  chain: Editor_chain,
  canSingle: Editor_canSingle,
  canChain: canChain,
  isActive: Editor_isActive,
  isHeadingActive: Editor_isHeadingActive,
  getLinkAttributes: getLinkAttributes,
  getHTML: Editor_getHTML,
  getText: Editor_getText,
  isEmpty: Editor_isEmpty,
  state: Editor_state,
  internal_startDomObserver: Editor_internal_startDomObserver,
  internal_stopDomObserver: Editor_internal_stopDomObserver,
  Config: Editor_Config
};

var ReactTiptap_EditorContent = {
  make: React.EditorContent
};

var ReactTiptap = {
  useEditor: useEditor,
  EditorContent: ReactTiptap_EditorContent
};

exports.Nodes = Nodes;
exports.Marks = Marks;
exports.Commands = Commands;
exports.ProseMirror = ProseMirror;
exports.Editor = Editor;
exports.ReactTiptap = ReactTiptap;
/* ReactTiptap Not a pure module */
